import React, { useState, useEffect} from 'react';
import {
  collection, orderBy, query, limit,
} from 'firebase/firestore';
import { useCollection } from 'react-firebase-hooks/firestore';

import {
  Accordion,
  AccordionHeader,
  AccordionBody,
} from '@material-tailwind/react';

import './Lister.css';

// import { getFunctions, httpsCallable, connectFunctionsEmulator } from 'firebase/functions';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import db from '../firebase';
import {formatFirebaseTimestamp} from '../utils';

function Lister(props) {
  const options = {
    snapshotListenOptions: { includeMetadataChanges: true },
  };

  const [manufacturer] = useState(props.default);
  const [selectedScrapeId, setSelectedScrapeId] = useState('EMPTY');

  const q = query(
    collection(db, `${props.listingSite}/${manufacturer}/${props.scrapesCollection}`),
    orderBy('started', 'desc'),
    limit(1),
  );
  const [value, loading, error] = useCollection(q, options);
  
  const queryString = `planecheck_listings/${manufacturer}/${props.scrapesCollection}/${selectedScrapeId}/listing_pages_progress_fast`;
  const queryStringScrapeData = `planecheck_listings/${manufacturer}/${props.scrapesCollection}/${selectedScrapeId}/listing_scrape_data`;

  const listing_pages_query = query(
    collection(db,queryString ),
    orderBy('started','desc')
   );

   const listing_scrape_data_query = query(
    collection(db,queryStringScrapeData ),
    orderBy('started', 'desc'),
   );

  const [listingPagesValue, listingPagesLoading, listingPagesEerror] = useCollection(listing_pages_query, options);
  const [listingScrapeDataValue, listingScrapeDataLoading, listingScrapeDataEerror] = useCollection(listing_scrape_data_query, options);
  
  const functions = getFunctions();
  
  // const qc = query(doc(db, `config/${props.configName}`));
  // const [config] = useDocument(qc, options);

  if (window.location.href.indexOf('localhost') > -1) {
    connectFunctionsEmulator(functions, '127.0.0.1', 5001);
  }

  // const [progressValues, setProgressValue] = useState({})

  useEffect(() => {

    if (value && value.docs.length > 0){
      setSelectedScrapeId(value.docs[0].id);
    }

  }, [value]);

  // useEffect(() => {

  //   async function getProgress(scrapeId) {
  //     const ref = collection(db, `${props.listingSite}/${manufacturer}/${props.scrapesCollection}/${scrapeId}/progress`);
  //     const scrapes = query(ref);

  //     const s = await getDocs(scrapes);
  //     return s;
  //   }

  //   if (!value){
  //     console.log('no value')
  //     return 
  //   } else{
  //     console.log("new value", value)
  //   }

  //   value.forEach((v)=>{

  //     console.log("scrape id", v.id)

  //     const progressValues ={};
  //     getProgress(v.id)
  //       .then((p)=>{
  //         console.log(p.docs)
  //         p.docs.forEach((page)=>{
  //           console.log(page.id, page.data())
  //           if (progressValues[v.id]){
  //             progressValues[v.id][page.id] = page.data().count;
  //           } else {
  //             progressValues[v.id] = {}
  //             progressValues[v.id][page.id] = page.data().count;
  //           }
  //         })
  //         console.log(progressValues)
  //         setProgressValue(progressValues);
  //       })
  //   })



  // }, [value, manufacturer, props.listingSite, props.scrapesCollection]);

  const scrapedListingCount = (dat) => {
    
    if (!dat) return 0;
    if (dat.totalCounter) return dat.totalCounter;
    if (!dat.totalListingCountBreakdown) return 0;
    const sum = Object.values(dat.totalListingCountBreakdown).reduce((a, b) => a + b, 0);
    return sum;
  };

  const percentageProgress = (dat) => {
    const sum = scrapedListingCount(dat);
    return Math.round(sum / dat.initialListingCount * 100);
  };

  const timeTakenForPage = (doc) => {

    if (!doc.data().updated || !doc.data().started){
      return "N/A";
    } 
    const diff = doc.data().updated.toDate() - doc.data().started.toDate();

    return (diff /1000/60).toFixed(1) + " m";
    
  };

  const timeForDetailsPage = (doc) => {

    if (!doc.data().updated || !doc.data().started){
      return "N/A";
    } 
    const diff = doc.data().updated.toDate() - doc.data().started.toDate();

    return (diff /1000).toFixed(1) + " s";
    
  };

  const uniqueSucceededCount = (doc) => {
    const ids = doc.data().successListingsIds;
    return ids ? ids.length : 0;
  };

  const statusForPage = (doc) => {
    const succeeded = uniqueSucceededCount(doc);
    const noListings = doc.data().noListings;

    if (succeeded && noListings){
      if (noListings === (doc.data().listingFailureCount + succeeded)){
        return `[ ${doc.data().listingFailureCount} failed / ${succeeded}]`
      }
      return succeeded === noListings ? "Success" : `[ ${noListings - succeeded} TODO ]`;
    }
    if (doc.data().started){
      return "*In progress...*";
    }

  }

  const totalTimeTaken = (doc) => {
    if (!doc.data().updated || !doc.data().started){
      return "N/A";
    } 
    const diff = doc.data().updated.toDate() - doc.data().started.toDate();
    return (diff /1000/60).toFixed(1) + " min";
  };

  const [open, setOpen] = React.useState(0);

  const handleOpen = (value) => {
    setOpen(open === value ? 0 : value);
    setSelectedScrapeId()
  }

  // const func = httpsCallable(functions, 'testBadParse');

  // const getProgress = (p) => {
  //   console.log("progress",p)
  //   return JSON.stringify(p)

  // }

  const timingInfo = (page, data) =>{

    if (data){


      const pageNo = page.replace('page','');
      const pageId = `page_${pageNo}`;
      const pageTiming = data.timing[pageId];
      
      const started = pageTiming.started;
      const completed = pageTiming.completed;

      const diff  = completed.toDate() - started.toDate();
      const minDiff = (diff /1000/60).toFixed(1) + " m";

      
      const start = formatFirebaseTimestamp(started);
      const comp = formatFirebaseTimestamp(completed);

      return ` ${start} [   ${minDiff}  ]Page atempts ${pageTiming.page_attempts} ----> ${comp}`;
    } 
    return `loading...`;

  }

  const computeScrapeMetrics = () => {
    const empty = {
      pages: 0,
      listingAttempts: 0,
      succeeded: 0,
      failed: 0,
      removed: 0,
      soft404: 0,
      deferred: 0,
      blockedTerminal: 0,
      totalAttempts: 0,
    };

    if (!listingPagesValue || !listingPagesValue.docs) {
      return empty;
    }

    return listingPagesValue.docs.reduce((acc, snap) => {
      const data = snap.data() || {};
      acc.pages += 1;
      acc.listingAttempts += data.listingAttempts || 0;
      acc.succeeded += data.succeeded || 0;
      acc.failed += data.listingFailureCount || 0;
      acc.removed += data.removedListingCount || 0;
      acc.soft404 += data.soft404Count || 0;
      acc.deferred += data.deferredRetryScheduled || 0;
      acc.blockedTerminal += data.blockedTerminalCount || 0;
      acc.totalAttempts += data.totalAttempts || 0;
      return acc;
    }, empty);
  };

  const metrics = computeScrapeMetrics();
  const successRate = metrics.listingAttempts ?
    ((metrics.succeeded / metrics.listingAttempts) * 100).toFixed(1) :
    "0.0";
  const failureRate = metrics.listingAttempts ?
    ((metrics.failed / metrics.listingAttempts) * 100).toFixed(1) :
    "0.0";

  return (
    <div>
      <div>
        {/* <
         onClick={getControllerUrls}>Get Controller Listing URLs</button> */}
        {/* <span>Document: {config && JSON.stringify(config.data().keywords)}</span> */}
        {/* <div>
                <Caller functionName="enqueueControllerGetListingPagesSingleCall" text={`Enque GLP`} params={{keyword:manufacturer }}></Caller>
            </div>  */}
        {/* <FormControl sx={{ m: 1, minWidth: 120 }}>
          <InputLabel id="demo-simple-select-label">Manufacturer</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={manufacturer}
            label="Manufacturer"
            onChange={handleChange}
          >
            {value
              && config.data().keywords.map((item, i) => (
                <MenuItem key={`key${i}`} value={item.toLowerCase()}>
                  {config.data().names[i]}
                </MenuItem>
              ))}
          </Select>
        </FormControl> */}



        {error && (
        <strong>
          Error:
          {JSON.stringify(error)}
        </strong>
        )}
        {loading && <span>Collection: Loading...</span>}
        {value
          && value.docs.map((doc, index) => (
            <Accordion open={open === index} key={doc.id}>
              <AccordionHeader onClick={() => handleOpen(index, doc.id)}>
                [
                {percentageProgress(doc.data())}
                %]
                {' '}
                {formatFirebaseTimestamp(doc.data().started)}
                {' '}
                [
                {scrapedListingCount(doc.data())}
                ] *
                {doc.data().errors && Object.keys(doc.data().errors).length}
                *
                {totalTimeTaken(doc)}
              </AccordionHeader>
              <AccordionBody>

                <div>
                  Scrape ID:
                  {doc.id}
                </div>
                <div>
                  Status:
                  {doc.data().status }
                </div>
                
                <div>
                  Listing Detail Pages Progress:
                  {doc.data().progress && Object.keys(doc.data().progress).sort().map((p)=>(<div key={p}>{p}:  {doc.data().progress[p]}</div>)) }
                </div>
                <div>
                  Pages:
                  {' '}
                  {(doc.data().progress && Object.keys(doc.data().progress).length)
                    || 0}
                </div>
                <div>
                  Initial Page Count:
                  {doc.data().pageCount}
                </div>
               
                
                <div>
                  Scraped count (inc):
                  {scrapedListingCount(doc.data())}
                </div>
                <div>
                  Initial Listings:
                  {doc.data().initialListingCount}
                </div>
                <div>
                <strong>Listing Page Progress:</strong>
                {listingPagesLoading && <span>Collection: Loading...</span>}
                {listingPagesEerror && <span>ERROR...</span>}
                  {!listingPagesLoading && !listingPagesEerror && (
                    <div className="my-3 rounded border border-blue-gray-100 p-3 bg-blue-gray-50">
                      <p className="font-semibold text-blue-gray-800">Scrape Metrics Panel</p>
                      <div className="grid grid-cols-2 md:grid-cols-4 gap-2 mt-2 text-sm">
                        <div>Pages: <strong>{metrics.pages}</strong></div>
                        <div>Listing Attempts: <strong>{metrics.listingAttempts}</strong></div>
                        <div>Succeeded: <strong>{metrics.succeeded}</strong></div>
                        <div>Failed: <strong>{metrics.failed}</strong></div>
                        <div>Removed: <strong>{metrics.removed}</strong></div>
                        <div>Soft-404 Hits: <strong>{metrics.soft404}</strong></div>
                        <div>Deferred Retries: <strong>{metrics.deferred}</strong></div>
                        <div>Blocked Terminal: <strong>{metrics.blockedTerminal}</strong></div>
                        <div>Total Attempts: <strong>{metrics.totalAttempts}</strong></div>
                        <div>Success Rate: <strong>{successRate}%</strong></div>
                        <div>Failure Rate: <strong>{failureRate}%</strong></div>
                      </div>
                    </div>
                  )}
                  {listingPagesValue 
                  && listingPagesValue.docs.map((doc, index) => (
                    <p key={doc.id}>{doc.id} [{doc.data().pageStatus}]:: {statusForPage(doc)} :: SUCCEEDED[{uniqueSucceededCount(doc)}] :: FAILED[{doc.data().listingFailureCount}]:: TOTAL ATTEMPTS {doc.data().totalAttempts} :: STARTED [{doc.data().listingAttempts}]  [Time taken {timeTakenForPage(doc)}]] :: {doc.data().proxy_used} </p>
                  ))}
                </div>
                <div>
                <strong>Listing Details Progress:</strong>
                {listingScrapeDataEerror && <span>ERROR</span>}
                {listingScrapeDataLoading && <span>Collection: Loading...</span>}
                  {listingScrapeDataValue 
                  && listingScrapeDataValue.docs.map((doc, index) => (
                    <p key={doc.id}>{doc.id} :: {doc.data().strategy}  :: TIME: { timeForDetailsPage(doc)} :: [PROXY {doc.data().proxy}]</p>
                  ))}
                </div>
                <div>
                  <strong>Updated Listings:</strong>
                  {doc.data().updatedListingCount}
                </div>
                {doc.data().errors && Object.keys(doc.data().errors).map((key) => (
                  <div key={key}>
                    {key}
                    {' '}
                    =++
                    {' '}
                    {doc.data().errors[key]}
                    {' '}
                  </div>
                ))}
                {doc.data().pages && Object.keys(doc.data().pages).map((key, index) => (
                  <div key={index}>
                    {key}
                    {' '}
                    ::
                    {' '}
                    {doc.data().pages[key] && doc.data().pages[key].data && doc.data().pages[key].data.length}
                    {' '}
                    ::  
                    {timingInfo(key, doc.data())}
                    {/* <button className="border p-1 bg-blue-300 text-white" onClick={(e) => investigateBadParse(doc.id, manufacturer, `page${index + 1}`)}>Investigate</button> */}
                    {' '}
                  </div>
                ))}
              </AccordionBody>
            </Accordion>
          ))}
      </div>
          
    </div>
  );
}

export default Lister;
